const jasonQuotes = [
  {
    jason: "momoa",
    film: "aquaman",
    quote: "Something something trident.",
  },
  {
    jason: "momoa",
    film: "aquaman",
    quote: "You killed innocent people. You ask the sea for mercy.",
  },
  {
    jason: "momoa",
    film: "aquaman",
    quote: "Okay, so we're doing things a little out of order. S*** happens.",
  },
  {
    jason: "momoa",
    film: "aquaman",
    quote:
      "Put two ships in the open sea without wind or tide, they will come together.",
  },
  {
    jason: "momoa",
    film: "justiceleague",
    quote:
      "So, let me get this straight. You do it dressed like a bat? Like an actual bat.",
  },
  {
    jason: "momoa",
    film: "justiceleague",
    quote:
      "Icebergs in the harbour, four months since the last ship got through.",
  },
  {
    jason: "momoa",
    film: "justiceleague",
    quote: "My man!",
  },
  {
    jason: "momoa",
    film: "justiceleague",
    quote: "A strong man is strongest alone. You ever heard of that?",
  },
  {
    jason: "momoa",
    film: "justiceleague",
    quote: "I dig it.",
  },
  {
    jason: "momoa",
    film: "justiceleague",
    quote: "So, your genius plan is dying?",
  },
  {
    jason: "momoa",
    film: "justiceleague",
    quote: "You really are out of your mind.",
  },
  {
    jason: "momoa",
    film: "justiceleague",
    quote: "You tell anyone about this, you will meet every piranha I know!",
  },
  {
    jason: "momoa",
    film: "justiceleague",
    quote: "Ye-ah!",
  },
  {
    jason: "momoa",
    film: "dune",
    quote:
      "Dreams make good stories, but everything important happens when we're awake.",
  },
  {
    jason: "momoa",
    film: "dune",
    quote: "Let's fight like demons!",
  },
  {
    jason: "momoa",
    film: "dune",
    quote: "You cross swords with the Sardaukar, you know it.",
  },
  {
    jason: "momoa",
    film: "stargate",
    quote: "I was beginning to think you were afraid to fight.",
  },
  {
    jason: "momoa",
    film: "conanbarbarian",
    quote: "I live, I love, I slay, and I am content.",
  },
  {
    jason: "momoa",
    film: "conanbarbarian",
    quote:
      "Run from me... and I will tear apart the mountains to find you! I will follow you to Hell!",
  },
  {
    jason: "momoa",
    film: "see",
    quote:
      "Every child eventually comes to a bridge that they must cross alone",
  },
  {
    jason: "momoa",
    film: "see",
    quote:
      "You'd be surprised how much you can accomplish before your eyes even get open in the morning.",
  },
  {
    jason: "momoa",
    film: "see",
    quote: "I have many things I'm sorry for. Many regrets.",
  },
  {
    jason: "momoa",
    film: "see",
    quote: "  I never regret anything that I did for my children.",
  },
  {
    jason: "momoa",
    film: "gameofthrones",
    quote:
      "I heard what you did. Choose any horse you wish, it is yours. I make this gift to you.",
  },
  {
    jason: "momoa",
    film: "gameofthrones",
    quote: "I will give him the Iron Chair that his mother's father sat upon.",
  },
  {
    jason: "momoa",
    film: "gameofthrones",
    quote: "I will give him Seven Kingdoms.",
  },
  {
    jason: "momoa",
    film: "gameofthrones",
    quote: "I, Drogo, will do this.",
  },
  {
    jason: "momoa",
    film: "gameofthrones",
    quote:
      "To my son, The Stallion Who Will Mount the Word, I will also pledge a gift.",
  },
  {
    jason: "momoa",
    film: "gameofthrones",
    quote: "Moon of My Life, are you hurt?",
  },
  {
    jason: "momoa",
    film: "fastx",
    quote: "What? The Vatican? Wow. Bet you guys are going to hell.",
  },
  {
    jason: "momoa",
    film: "fastx",
    quote:
      "That's the problem with having a big family. You can't save them all.",
  },
  {
    jason: "momoa",
    film: "fastx",
    quote: "Never accept death when suffering is owned.",
  },
  {
    jason: "momoa",
    film: "fastx",
    quote: "Here we go!",
  },
  {
    jason: "momoa",
    film: "fastx",
    quote:
      "Dom drove the car. But you... You pulled the trigger. And now I'm gonna make you suffer.",
  },
  {
    jason: "momoa",
    film: "fastx",
    quote: "Hey dorks, what are we blowing up?",
  },
  {
    jason: "momoa",
    film: "minecraft",
    quote: "I'm more of a sister to him than you'll ever be.",
  },
  {
    jason: "momoa",
    film: "minecraft",
    quote: "Vaya con dios. It means goodbye, brother.",
  },
  {
    jason: "momoa",
    film: "minecraft",
    quote:
      "Tell my story in song. Keep it metal, keep it heavy, with real instruments.",
  },
  {
    jason: "momoa",
    film: "chiefofwar",
    quote: "Who among us will be consumed by the weakeness of their gods?",
  },
  {
    jason: "momoa",
    film: "chiefofwar",
    quote: "We fight with the God of War!",
  },
  {
    jason: "momoa",
    film: "chiefofwar",
    quote:
      "Our throats will be satiated feasting on you, the worthless fish of the shallows.",
  },
];

module.exports = jasonQuotes;
